export class ReturnRentalMovementModel {
  public dataConsegna: Date;
  public kmConsegna: number;
  public carburanteConsegna: string;
  public carburanteRientro: string;
  public dataRientro: Date;
  public kmRientro: number;
  public danniRientro: string;
}
